import React from 'react';
import { useSelector } from 'src/store';

const LogoWhite = (props) => {
  const { systemSettings } = useSelector((state) => state.user);
  return <img alt="Logo" src={systemSettings ? systemSettings.logos.option1 : "/logo_white.png"} {...props} />;
};

export default LogoWhite;
